export const normalizeVariantInventoryLevel = variant => {
  const quantitiesAvailable = variant?.inventoryItem?.inventoryLevel?.quantities?.find(
    q => q.name === 'available'
  )?.quantity

  return {
    ...variant,
    weight: variant?.inventoryItem?.measurement?.weight?.value,
    currentAvailable: variant?.inventoryQuantity ?? quantitiesAvailable ?? 0
  }
}

export const getVariantInventoryLevel = variants => {
  return variants?.map(normalizeVariantInventoryLevel)
}
